/**
* SEO Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the SEO Cards component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'seo-cards',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.seo-cards' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--seo-cards' )[0], {
          type: 'loop',
          pagination: false,
          arrows: true,
          // gap: '20px',
          autoWidth: true,
        } );

        const bar = splide.root.querySelector( '.seo-cards__progress-bar' );

        // Updates the bar width whenever the carousel moves:
        splide.on( 'mounted move', function() {
          const end = splide.Components.Controller.getEnd() + 1;
          const rate = Math.min( ( splide.index + 1 ) / end, 1 );
          bar.style.width = String( 100 * rate ) + '%';
        } );

        splide.mount();
      } );

      $( document ).on( 'click', '.js-init-seo-card-popup', function( e ) {
        e.preventDefault();
        const target = $( this ).attr( 'href' );

        $.magnificPopup.open( {
          items: {
            src: target,
          },
          type: 'inline',
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false,
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'seo-cards', COMPONENT );
} )( app );
